import styled, { css } from 'styled-components';
import { colors } from '../../styles/stylesheets';

import { allState } from './data';

export const Container = styled.ol`
  font-size: 12px;
  line-height: 16px;
  padding-left: 15px;
  display: flex;
  flex-direction: column;
`;
export const Step = styled.li`
  position: relative;
  padding-bottom: 24px;
  display: flex;
  ${({ status }) => status === allState.active.status && css`
    font-weight: 500;
    color: ${colors.info};
  `}
  ${({ status }) => status === allState.prev.status && css`
    font-weight: 500;
  `}
  ${({ status }) => status === allState.next.status && css`
    font-weight: 400;
    color: ${colors.greyMedium};
  `}
`;
export const StepIcon = styled.div`
  width: 12px;
  height: 12px;
  margin: 2px;
  border-radius: 12px;
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 12px;
    height: 12px;
  }
`;
export const StepText = styled.p`
  flex: 1;
  margin-left: 8px;
`;
export const StepLine = styled.div`
  position: relative;
  top: calc(16px + 8px/2);
  left: 8px;
  width: 1px;
  border-left: 1px dashed ${colors.greyLighter};
  ${({ status }) => status === allState.active.status && css`
    border-left: 1px solid ${colors.info};
  `}
  ${({ status }) => status === allState.prev.status && css`
    border-left: 1px solid ${colors.greyMedium};
  `}
  ${({ last }) => last && css`
    display: none;
  `}
`;
